var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function RocketSolid(_a) {
    var size = _a.size, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, __assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M14.265 10.741a3.654 3.654 0 0 1-1.032 3.11l-1.279 1.279c-2.194 2.194-2.537 1.851-3.083-.934l-.467-2.335c-.522-.283-.952-.588-1.294-.93-.341-.341-.646-.77-.93-1.293L3.847 9.17C1.02 8.585.718 8.28 2.912 6.088l1.29-1.29a3.653 3.653 0 0 1 3.074-1.036c.103.014.257.074.4.13.13.052.253.1.324.108C9.964 2.291 12.858.54 15.733.388a1.827 1.827 0 0 1 1.92 1.92C17.503 5.193 15.719 8.035 14 10c.008.066.063.196.12.335.064.15.131.311.145.406Zm-1.25-3.671a1.37 1.37 0 1 1-1.937-1.937 1.37 1.37 0 0 1 1.938 1.937ZM2.47 11.108a1.467 1.467 0 0 1 1.618.376l2.204 2.111.024.024c.46.38.654 1.017.451 1.606l-.598 1.742c-.203.588-1.052.558-1.353-.049l-.546-1.1-2.62 1.55c-.634.43-1.505-.404-1.102-1.055l1.436-2.685-1.122-.498c-.62-.275-.686-1.122-.106-1.35l1.714-.672Z" }) })));
}
export default RocketSolid;
